var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#202326",
    strokeWidth: 0.846,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.02 6.25h2.605c.575 0 1.042.466 1.042 1.042v6.86c0 .276-.11.54-.305.736l-2.515 2.515c-.196.196-.46.305-.737.305H5.208a1.042 1.042 0 0 1-1.041-1.041V7.292c0-.576.466-1.042 1.041-1.042h2.605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.708v-3.125c0-.575.466-1.041 1.042-1.041h3.125M8.854 3.646a1.563 1.563 0 1 0 3.125 0 1.563 1.563 0 0 0-3.125 0h0zM10.417 8.854V5.208M6.77 11.458h7.293M6.77 14.583h3.126"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJob);
export default __webpack_public_path__ + "static/media/iconJob.562b2aa9363b61162895bd4b27835d70.svg";
export { ForwardRef as ReactComponent };